/* eslint-disable */

// ** Module imports **
import React from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import moment from "moment-timezone";
import { withRouter } from "react-router";

// ** Material UI imports **
import Input, { InputLabel } from "material-ui/Input";
import { CircularProgress } from "material-ui/Progress";
import { withStyles } from "material-ui/styles";
import green from "material-ui/colors/green";
import { FormControl } from "material-ui/Form";
import MenuItem from "material-ui/Menu/MenuItem";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import Card, { CardHeader, CardContent } from "material-ui/Card";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { getTimeZones } from "../../utils/timeZone/TimeZones"
import { getRequiredErrorMessage } from "../../utils/formValidation/ErrorMessages";


// ** React plugin **
import { Row } from 'react-flexbox-grid';


// ** Actions **
import {
  launchDatabaseServiceManualAggregation,
} from "../../actions";

// ** Custom components **
// import LoadingCircle from "../commons/LoadingCircle";

// ** Constants **
import { AggregationPeriodTypes } from "../../constants/AggregationPeriodTypes";
import { AssetMeteringPeriodTypes } from "../../constants/AssetMeteringPeriodTypes";

const styles = theme => ({
  lastMainButton: {
    marginLeft: 0, 
    marginTop: 40,
  },
  indentedContent: {
    marginLeft: 10, 
    marginBottom: 20
  },
  subTitle: {
    marginLeft: 0
  },
  inputWithMargin: {
    marginRight: 15
  },
  inputTextFormat: {
    minWidth: 200,
    fontSize: "13px"
  },
  buttonProgress: {
    color: green[500],
    marginTop: 6,
    marginLeft: 6,
    zIndex: 1000
  },
});


const timeZones = getTimeZones();

class DatabaseServiceManualAggregation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      source: "GEMS",
      source_id: "MAREGH",
      asset: "MAREGES",
      aggregation_period_type: "day",
      aggregation_period_number: 1,
      asset_metering_period_number: 1,
      asset_metering_period_type: "hour",
      start_date: moment("2020-10-02T00:00:00.000+0000").toDate(),
      end_date: moment("2020-10-03T00:00:00.000+0000").toDate(),
      timezone: "Europe/Paris",
      ignore_check_missing_value: false,
      aggregation_status: "live",
      production_type: "Production"
    }
  }

  /*
  export interface IDatabaseServiceManualAggregationCall {
    source: string;
    source_id: string;
    asset: string;
    production_type: EAssetType;
    asset_metering_period_type: EPeriodType; 
    asset_metering_period_number: number; 
    aggregation_period_type: EPeriodType;
    aggregation_period_number: number;
    from_date_local: Date;
    to_date_local: Date;
    moment_timezone: string;
    ignore_check_missing_value: boolean;
    status: EAggregatedAssetMeteringStatus;
  }
  */

  handleCallDatabaseServiceManualAggregation = () => {
    let manualAggregationOptions = {
      source: this.state.source,
      source_id: this.state.source_id,
      asset: this.state.asset,
      production_type: this.state.production_type,
      asset_metering_period_type: this.state.asset_metering_period_type, 
      asset_metering_period_number: this.state.asset_metering_period_number, 
      aggregation_period_type: this.state.aggregation_period_type,
      aggregation_period_number: this.state.aggregation_period_number,
      from_date_local: this.state.start_date,
      to_date_local: this.state.end_date,
      moment_timezone: this.state.timezone,
      ignore_check_missing_value: this.state.ignore_check_missing_value,
      status: this.state.aggregation_status,
    };
 
    this.props.launchDatabaseServiceManualAggregation(manualAggregationOptions);
  };

  render() {
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className={classes.root}>
        <Card className={classes.card} style={{ marginTop: 40 }}>
          <CardHeader
              title={t("Database service manual aggregation")}
            />
          <CardContent>
            <Grid item xs={12}>
              <Row className={classes.subTitle}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontSize: "0.875rem"}}
                >
                  Source selection
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-source">
                    Source
                  </InputLabel>
                  <Input
                    id="adornment-source"
                    type="text"
                    value={this.state.source}
                    autoComplete="Source"
                    onChange={(event) => { this.setState({ source: event.target.value }) }}
                  />
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-source-id">
                    Source ID
                  </InputLabel>
                  <Input
                    id="adornment-source-id"
                    type="text"
                    value={this.state.source_id}
                    autoComplete="Source ID"
                    onChange={(event) => { this.setState({ source_id: event.target.value }) }}
                  />
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-asset-id">
                    Asset ID
                  </InputLabel>
                  <Input
                    id="adornment-asset-id"
                    type="text"
                    value={this.state.asset}
                    autoComplete="Asset ID"
                    onChange={(event) => { this.setState({ asset: event.target.value }) }}
                  />
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <TextField
                    style={{ fontSize: "13px", minWidth: 200, marginTop: 0 }}
                    label="Asset type"
                    id="select-asset-type"
                    select
                    value={this.state.production_type}
                    onChange={(event) => { this.setState({ production_type: event.target.value }) }}
                    margin="normal"
                  >
                    <MenuItem value="">
                      -
                    </MenuItem>
                    <MenuItem value="Production">
                      Production
                    </MenuItem>
                    <MenuItem value="Consumption">
                      Consumption
                    </MenuItem>
                  </TextField>
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <TextField
                    style={{ fontSize: "13px", minWidth: 200, marginTop: 0 }}
                    id="select-status"
                    label="Status"
                    select
                    value={this.state.aggregation_status ? this.state.aggregation_status : ""}
                    onChange={(event) => { this.setState({ aggregation_status: event.target.value }) }}
                    margin="normal"
                  >
                    <MenuItem key="" value="">
                      -
                    </MenuItem>
                    <MenuItem key="live" value="live">
                      Live
                    </MenuItem>
                    <MenuItem key="official" value="official">
                      Official
                    </MenuItem>
                  </TextField>
                </FormControl>
                <FormControlLabel
                  className={classes.inputWithMargin}
                  control={
                    <Checkbox
                      onChange={(event) => { 
                        this.setState({ ignore_check_missing_value: !this.state.ignore_check_missing_value }) 
                      }}
                      value={this.state.ignore_check_missing_value}
                      color="primary"
                    />
                  }
                  label="Ignore check missing value"
                />
              </Row> 
              <Row className={classes.subTitle}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontSize: "0.875rem"}}
                >
                  Date range
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>
                <FormControl className={classes.inputWithMargin}>
                  <TextField
                    id="select-time-zone-aggregation"
                    select
                    label="Timezone "
                    validators={["isRequired"]}
                    errorMessages={[getRequiredErrorMessage()]}
                    className={classes.textField}
                    value={this.state.timezone}
                    onChange={(event) => { 
                      let newTimeZone = event.target.value;
                      let newStartDate = moment(this.state.start_date).clone().tz(newTimeZone, true).toDate()
                      let newEndDate = moment(this.state.end_date).clone().tz(newTimeZone, true).toDate()
                      this.setState({ start_date: newStartDate }) 
                      this.setState({ end_date: newEndDate }) 
                      this.setState({ timezone: newTimeZone }) 
                    }}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu
                      }
                    }}
                    margin="normal"
                    style={{ width: 140 }}
                  >
                    {timeZones.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Row>
              <Row className={classes.indentedContent}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <FormControl className={classes.inputWithMargin}>
                    <KeyboardDatePicker
                      format="dd/MM/yyyy"
                      openTo={"year"}
                      id="database-service-start-date"
                      label="Start date"
                      value={this.state.start_date}
                      onChange={(newDate) => { 
                        if(!moment(newDate).isValid() || !newDate) {
                          newDate = null;
                        }
                        
                        this.setState({ start_date: newDate });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </FormControl>
                  <FormControl className={classes.inputWithMargin}>
                    <KeyboardTimePicker
                      id="database-service-start-time"
                      label="Start time"
                      ampm={false}
                      value={this.state.start_date}
                      onChange={(newDate) => { 
                        if(!moment(newDate).isValid() || !newDate) {
                          newDate = null;
                        }
                        
                        this.setState({ start_date: newDate });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                    />
                  </FormControl>
                </MuiPickersUtilsProvider>    
              </Row>
              <Row>
                <Typography variant="caption" style={{ color: "rgba(0, 0, 0, 0.54)", marginLeft: 20 }}>
                  Local start date on selected timezone: {
                    moment(this.state.start_date)
                    .clone()
                    .tz(this.state.timezone, true)
                    .format()}
                </Typography>
              </Row>
              <Row>
                <Typography variant="caption" style={{ color: "rgba(0, 0, 0, 0.54)", marginLeft: 20, marginBottom: 20 }}>
                  UTC : {moment(this.state.start_date).startOf('ms').toDate().toISOString()}
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <FormControl className={classes.inputWithMargin}>
                    <KeyboardDatePicker
                      format="dd/MM/yyyy"
                      openTo={"year"}
                      id="database-service-end-date"
                      label="End date"
                      value={this.state.end_date}
                      onChange={(newDate) => { 
                        if(!moment(newDate).isValid() || !newDate) {
                          newDate = null;
                        }
                        
                        this.setState({ end_date: newDate });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </FormControl>
                  <FormControl className={classes.inputWithMargin}>
                    <KeyboardTimePicker
                      id="time-picker"
                      label="End time"
                      ampm={false}
                      value={this.state.end_date}
                      onChange={(newDate) => { 
                        if(!moment(newDate).isValid() || !newDate) {
                          newDate = null;
                        }
                        
                        this.setState({ end_date: newDate });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                    />
                  </FormControl>
                </MuiPickersUtilsProvider>    
              </Row>
              <Row>
                <Typography variant="caption" style={{ color: "rgba(0, 0, 0, 0.54)", marginLeft: 20 }}>
                  Local end date on selected timezone: {
                    moment(this.state.end_date)
                    .clone()
                    .tz(this.state.timezone, true)
                    .format()}
                </Typography>
              </Row>
              <Row>
                <Typography variant="caption" style={{ color: "rgba(0, 0, 0, 0.54)", marginLeft: 20, marginBottom: 20 }}>
                  UTC : {this.state.end_date.toISOString()}
                </Typography>
              </Row>
              <Row className={classes.subTitle}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontSize: "0.875rem"}}
                >
                  Asset Metering
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>  
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-period-number">
                    Period number
                  </InputLabel>
                  <Input
                    id="adornment-period-number"
                    type="text"
                    value={this.state.asset_metering_period_number}
                    onChange={(event) => { this.setState({ asset_metering_period_number: event.target.value }) }}
                  />
                </FormControl>
                <TextField
                  style={{ fontSize: "13px", width: 140 }}
                  id="select-period-type"
                  select
                  value={
                    this.state.asset_metering_period_type ? this.state.asset_metering_period_type : AssetMeteringPeriodTypes
                  }
                  onChange={(event) => { this.setState({ asset_metering_period_type: event.target.value }) }}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu
                    }
                  }}
                  margin="normal"
                  >
                  {AssetMeteringPeriodTypes.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Row>
              <Row className={classes.subTitle}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontSize: "0.875rem"}}
                >
                  Aggregation
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-period-number">
                    Period number
                  </InputLabel>
                  <Input
                    id="adornment-period-number"
                    type="text"
                    value={this.state.aggregation_period_number}
                    onChange={(event) => { this.setState({ aggregation_period_number: event.target.value }) }}
                  />
                </FormControl>
                <TextField
                  id="select-aggregation-period-type"
                  select
                  style={{ fontSize: "13px", width: 140 }}
                  value={
                    this.state.aggregation_period_type ? this.state.aggregation_period_type : AggregationPeriodTypes
                  }
                  onChange={(event) => { this.setState({ aggregation_period_type: event.target.value }) }}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu
                    }
                  }}
                  margin="normal"
                >
                  {AggregationPeriodTypes.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Row>
              <Row className={classes.lastMainButton}>
                <Button
                  type="submit"
                  variant="raised"
                  color="primary"
                  onClick={this.handleCallDatabaseServiceManualAggregation}
                  disabled={
                    !this.state.source ||
                    !this.state.source_id ||
                    !this.state.asset ||
                    !this.state.asset_metering_period_number ||
                    !this.state.asset_metering_period_type ||
                    !this.state.aggregation_period_number ||
                    !this.state.aggregation_period_type ||
                    !this.state.aggregation_status ||
                    !this.state.production_type ||
                    !this.state.timezone ||
                    !this.state.start_date ||
                    !this.state.end_date ||
                    this.state.end_date <= this.state.start_date ||
                    this.props.callingDatabaseService
                  }
                >
                  Launch manual aggregation
                </Button>
                {this.props.callingDatabaseService && <CircularProgress size={24} className={classes.buttonProgress} />}
              </Row>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({
  databaseServiceReducer
}) => {
  const { 
    callingDatabaseService
  } = databaseServiceReducer;

  return { 
    callingDatabaseService
  };
};

const mapDispatchToProps = {
  launchDatabaseServiceManualAggregation,
};

DatabaseServiceManualAggregation = withStyles(styles, { name: "DatabaseServiceManualAggregation" })(DatabaseServiceManualAggregation);
DatabaseServiceManualAggregation = translate("translations")(DatabaseServiceManualAggregation);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DatabaseServiceManualAggregation)
);



// WEBPACK FOOTER //
// ./src/components/Maintenance/DatabaseServiceManualAggregation.js